import { render, staticRenderFns } from "./PopoverRosterPatientOptions.vue?vue&type=template&id=a9424de4&scoped=true"
import script from "./PopoverRosterPatientOptions.vue?vue&type=script&lang=js"
export * from "./PopoverRosterPatientOptions.vue?vue&type=script&lang=js"
import style0 from "./PopoverRosterPatientOptions.vue?vue&type=style&index=0&id=a9424de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9424de4",
  null
  
)

export default component.exports